import {detectNodeTypeArr} from "@/Utility0";

export const getMarkById = (editor,targetId) => {
    let content:any = []
    editor?.state?.doc?.descendants((node, pos) => {
        if (node.attrs?.highlightImgUrl) {
            content.push({
                listId: crypto.randomUUID(),
                type: node.type.name,
                color: '#ffd400',
                content: node.attrs?.highlightImgUrl,
                pos: pos, //即start
                end: pos + node.nodeSize,
                id: node.attrs?.id, //生成唯一性link
                selectStatus: false,
                editStatus: false,
                noteText: node.attrs?.noteText, // 笔记,
                node: node,
            })
            return
        }
        if (node.attrs?.blockHighlight) {
            // 块内容默认必然是黄色的
            content.push({
                listId: crypto.randomUUID(),
                type: node.type.name,
                color: '#ffd400',
                content: node.textContent,
                pos: pos, //即start
                end: pos + node.nodeSize,
                id: node.attrs?.id, //生成唯一性link
                node: node,
                selectStatus: false,
                editStatus: false,
                noteText: node.attrs?.noteText, // 笔记,
            })
            return
        }
        if (getHighlightRelation(editor,pos)) {
            return;
        }


        node?.marks.forEach(mark => {
            if (mark.type.name === 'highlight') {
                // 连续mark合并
                if (mark.attrs?.id === content.at(-1)?.id) {
                    content[content.length - 1].content = `${content[content.length - 1].content}\n${node.text}`
                    content[content.length - 1].end = pos + node.text.length
                } else {
                    content.push({
                        listId: crypto.randomUUID(),
                        type: 'text',
                        color: mark.attrs?.color,
                        content: node.text,
                        pos: pos, //即start
                        end: pos + node.text.length,
                        id: mark.attrs?.id, //生成唯一性link
                        selectStatus: false,
                        noteText: mark.attrs?.noteText, // 笔记,
                        editStatus: false,
                        node: mark
                    })
                }
            }
        })
    });
    content.filter(item => item.id === targetId)
    return content.filter(item => item.id === targetId)[0]
}

// 遍历拿到hightlight内容 暂时不处理block部分
function getHighlightRelation(editor,pos) {
    const resolvedPos = editor?.state.doc.resolve(pos);
    // 获取当前节点的父节点
    const parentNode = resolvedPos.node(resolvedPos.depth - 1);
    // 获取当前节点的祖父节点（如果存在的话）
    const grandNode = resolvedPos.node(resolvedPos.depth - 2);
    // 获取当前节点的曾祖父节点（如果存在的话）
    const greatGrandNode = resolvedPos.node(resolvedPos.depth - 3);
    if (detectNodeTypeArr.includes(parentNode?.type?.name) && parentNode.attrs.blockHighlight) {
        return true
    }
    if (detectNodeTypeArr.includes(grandNode?.type?.name) && grandNode.attrs.blockHighlight) {
        return true
    }
    if (detectNodeTypeArr.includes(greatGrandNode?.type?.name) && greatGrandNode.attrs.blockHighlight) {
        return true
    }
    return false;
}